/**
 * 支持的文件格式配置
 */
export const CLOUD_TRANSCODE_SUPPORTED_FORMATS = {
    // 视频格式
    video: {
        input: [
            'mp4',
            'mov',
            'webm',
            'm4v',
            '3gp',
            'asf',
            'avi',
            'f4v',
            'flv',
            'hevc',
            'm2ts',
            'm2v',
            'mjpeg',
            'mkv',
            'mpeg',
            'mpg',
            'mts',
            'mxf',
            'ogv',
            'swf',
            'ts',
            'wmv',
            'wtv',
            '3g2',
            'rm',
            'vob',
        ],
        output: ['mp4'],
    },
    // 音频格式
    audio: {
        input: ['aac', 'mp3', 'm4a', 'flac', 'ogg', 'wav', 'aiff', 'wma', 'opus'],
        output: ['wav'],
    },
    // 图片格式
    image: {
        input: [
            'png',
            'jpg',
            'webp',
            // 'gif',
            'bmp',
            'ico',
            'jpeg',
            'psd',
            'raw',
            'heic',
            'dng',
            'tif',
            'tiff',
            'pcd',
            'jfif',
            'ai',
        ],
        output: ['png'],
    },
};

export const CLOUD_TRANSCODE_SUPPORTED_IMAGE_FORMATS =
    'image/png,image/jpeg,image/webp,image/bmp,image/x-icon,image/vnd.adobe.photoshop,image/x-raw,image/heic,image/heif,image/x-adobe-dng,image/tiff,image/x-photo-c';
export const CLOUD_TRANSCODE_SUPPORTED_VIDEO_FORMATS =
    'video/mp4,video/quicktime,video/webm,video/x-m4v,video/mp4,video/3gpp2,video/3gpp,video/x-ms-asf,video/x-msvideo,video/x-f4v,video/x-flv,video/hevc,video/mp2t,video/mpeg,video/x-motion-jpeg,video/x-matroska,video/mpeg,application/mxf,video/ogg,application/x-shockwave-flash,video/mp2t,video/x-ms-wmv,video/x-ms-wtv,application/vnd.rn-realmedia,video/dvd';
export const CLOUD_TRANSCODE_SUPPORTED_AUDIO_FORMATS =
    'audio/aac,audio/mpeg,audio/mp4,audio/x-m4a,audio/flac,audio/ogg,audio/wav,audio/aiff,video/x-ms-wma,audio/opus,audio/ogg; codecs=opus';
